import { useState } from "react";

const faqs = [
  {
    q: "翻页和下拉阅读如何切换？",
    a: "在阅读页顶部点击阅读模式按钮，即可在翻页、下拉两种模式间一键切换。翻页模拟实体书左右滑动体验，下拉则像刷信息流一样连续阅读，随时按你的习惯来。",
  },
  {
    q: "夜间模式怎么开启？",
    a: "点击阅读页右上角的月亮图标即可开启夜间模式，自动切换为低亮度、低眩光的深色暖调画面。夜间模式会记住你的选择，下次打开自动沿用，追更更护眼。",
  },
  {
    q: "离线缓存如何使用？",
    a: "进入任意漫画详情页，点击“缓存”按钮即可把整部作品下载到本地。缓存后在地铁、电梯或信号不佳的环境下也能流畅阅读，无需联网。缓存内容可在“我的-缓存”中管理。",
  },
  {
    q: "横屏阅读适合哪些场景？",
    a: "横屏阅读会自动放大页面并支持双开翻页，特别适合跨页大场面、全屏分镜的漫画作品，配合平板或手机横置使用体验更佳。",
  },
  {
    q: "目录跳转怎么快速定位章节？",
    a: "阅读页底部或菜单栏的目录按钮会弹出完整章节目录，支持按话数、更新排序，一键直达任意章节，追更和回顾都很方便。",
  },
];

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="mx-auto w-full max-w-4xl px-4 py-14 md:px-8 md:py-20">
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <div className="text-center">
        <span className="text-sm font-semibold tracking-wide text-primary-500">常见问题</span>
        <h2 className="mt-2 text-2xl md:text-4xl">关于阅读，你想知道的</h2>
      </div>

      <div className="mt-10 space-y-3">
        {faqs.map((f, idx) => {
          const open = openIdx === idx;
          return (
            <div
              key={f.q}
              className={`overflow-hidden rounded-lg border transition-colors ${
                open ? "border-primary-300 bg-background-100" : "border-background-200/70 bg-background-100/60"
              }`}
            >
              <button
                type="button"
                onClick={() => setOpenIdx(open ? null : idx)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
              >
                <h3 className="font-heading text-base text-foreground-950">{f.q}</h3>
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-lg transition-transform ${
                    open ? "rotate-180 bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-700"
                  }`}
                >
                  <i className="ri-arrow-down-s-line" />
                </span>
              </button>
              <div
                className={`grid transition-all duration-300 ${
                  open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                }`}
              >
                <div className="overflow-hidden">
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700">{f.a}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}